Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontBold = _STYLES$useStyles.fontBold;
  var container = {
    width: '100%'
  };
  var textContainer = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: spacing.xs
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    textContainer.flexDirection = 'column';
  }
  var title = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: COLORS.aubergine
  });
  var description = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: COLORS.aubergine
  });
  var barContainer = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  };
  var item = {
    backgroundColor: COLORS.mushroom,
    height: (0, _styles.getREM)(0.5),
    borderRadius: (0, _styles.getREM)(0.25),
    flex: 1,
    overflow: 'hidden',
    position: 'relative'
  };
  if (bp.tablet) {
    item.height = (0, _styles.getREM)(0.625);
    item.borderRadius = (0, _styles.getREM)(0.3125);
  }
  if (bp.desktop) {
    item.height = (0, _styles.getREM)(0.78375);
    item.borderRadius = (0, _styles.getREM)(0.391875);
  }
  var item_gap = {
    marginLeft: (0, _styles.getREM)(0.625)
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    item_gap.marginLeft = (0, _styles.getREM)(1);
  }
  var itemBar = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: COLORS.aubergine
  };
  var value = {
    position: 'absolute',
    left: (0, _styles.getREM)(-99999),
    fontSize: 0
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    textContainer: textContainer,
    title: title,
    description: description,
    barContainer: barContainer,
    item: item,
    item_gap: item_gap,
    itemBar: itemBar,
    value: value
  });
  return {
    styles: styles
  };
};